// src/HighlightsCarousel.js

import React from 'react';
import Slider from 'react-slick'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'; 

// [MODIFICACIÓN CLAVE]
// Usar rutas absolutas que apuntan a la carpeta public/images/slider
const HIGHLIGHT_IMAGES = [
    "/images/slider/slide_01.jpg", 
    "/images/slider/slide_02.jpg", 
    "/images/slider/slide_03.jpg", 
    "/images/slider/slide_04.jpg", 
    "/images/slider/slide_05.jpg",
    "/images/slider/slide_06.jpg", 
    "/images/slider/slide_07.jpg", 
    "/images/slider/slide_08.jpg", 
    "/images/slider/slide_09.jpg", 
    "/images/slider/slide_10.jpg",  
    // Añade tantas rutas como imágenes tengas en la carpeta /public/images/slider
];

function HighlightsCarousel() {
    
    // ... (El objeto settings se queda igual)
    const settings = {
        dots: false,         // Ocultar indicadores (por estética del diseño)
        infinite: true,      // Carrusel infinito
        speed: 500,
        
        // --- PROPIEDADES CLAVE PARA EL DISEÑO ---
        slidesToShow: 3.2,     // Mostrar 3 slides completas y .2 de la cuarta
        slidesToScroll: 1,     // Desplazar 1 slide
        centerMode: false,     // Asegurarnos de que inicie desde la izquierda
        // ----------------------------------------
        
        autoplay: true,      
        autoplaySpeed: 3000, 
        cssEase: "linear",

        // Opcional: Configuración para móviles (responsivo)
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.2, // En tabletas, mostrar 2 y un poco de la tercera
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.2, // En móviles, mostrar 1 y un poco de la segunda
                    arrows: false,
                    autoplaySpeed: 8000, 
                }
            }
        ]
    };

    return (
        <div className="carousel-container">
            <Slider {...settings}>
                {HIGHLIGHT_IMAGES.map((url, index) => (
                    <div key={index} className="photo-item-slide">
                        {/* El tag <img> usa la URL local */}
                        <img 
                            src={url} 
                            alt={`Foto Destacada ${index + 1}`} 
                            className="carousel-image"
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default HighlightsCarousel;